export default __webpack_public_path__ + "static/media/how-it-works-bg.ed140458.jpg";